var CartDiscountType;
(function(CartDiscountType) {
    CartDiscountType["PERCENT"] = "PERCENT";
    CartDiscountType["AMOUNT"] = "AMOUNT";
})(CartDiscountType || (CartDiscountType = {}));

export { CartDiscountType };
//# sourceMappingURL=types.js.map
